"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Row = _interopRequireDefault(require("../Layout/Row"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _excluded = ["name", "value", "placeholder", "disabled", "onChange", "maxLength", "className", "style", "suffix", "prefix", "onFocus", "onBlur", "error", "jss"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: (0, _extends2["default"])({}, theme.typography.primary, _styles["default"].shared(theme), {
      '&:hover': _styles["default"].hover(theme),
      height: '46px'
    }),
    input: {
      border: 'none',
      height: '100%',
      width: '100%',
      backgroundColor: 'transparent',
      '&::placeholder': _styles["default"].placeholder(theme)
    },
    disabled: _styles["default"].disabled(theme),
    focused: _styles["default"].focused(theme),
    error: _styles["default"].error(theme),
    prefix: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    suffix: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  };
}, {
  name: 'Input'
});
exports.useStyles = useStyles;

var Input = /*#__PURE__*/_react["default"].forwardRef(function Input(_ref, ref) {
  var _cn;

  var name = _ref.name,
      value = _ref.value,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      maxLength = _ref.maxLength,
      className = _ref.className,
      style = _ref.style,
      suffix = _ref.suffix,
      prefix = _ref.prefix,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      error = _ref.error,
      jss = _ref.jss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var onInputFocus = function onInputFocus(e) {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  var onInputBlur = function onInputBlur(e) {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    wrap: false,
    justify: "between",
    align: "center",
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.disabled, disabled), (0, _defineProperty2["default"])(_cn, classes.focused, focused), (0, _defineProperty2["default"])(_cn, classes.error, error), _cn), className)
  }, prefix && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.prefix
  }, prefix), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    onChange: onChange,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    className: (0, _classnames["default"])(classes.input),
    name: name,
    value: value,
    disabled: disabled,
    placeholder: placeholder,
    ref: ref,
    maxLength: maxLength
  }, props)), suffix && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.suffix
  }, suffix));
});

Input.displayName = 'Input';
var _default = Input;
exports["default"] = _default;